<template>
  <div class="zhanwei4"></div>
  <div class="form1">
    <div>
      <div class="panel">
        <div class="panel_left">
          <el-form
            :model="form"
            label-width="auto"
            style="max-width: 600px"
            label-position="top"
            ref="ruleForm"
            status-icon
          >
            <el-form-item label="标题">
              <el-input v-model="form.startTitle" size="large" />
            </el-form-item>

            <el-form-item label="内容">
              <el-input
                v-model="form.startContent"
                type="textarea"
                size="large"
                rows="10"
                maxlength="500"
                show-word-limit
              />
            </el-form-item>

            <el-form-item label="展示媒体类型">
              <el-radio-group v-model="form.mediaType" size="large">
                <el-radio-button label="image">图片</el-radio-button>
                <!--                <el-radio-button label="video">视频链接</el-radio-button>-->
              </el-radio-group>
            </el-form-item>

            <el-form-item label="上传图片" v-if="form.mediaType === 'image'">
              <el-upload
                class="avatar-uploader"
                :action="UpdateApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList"
                :disabled="allowUpload"
              >
                <el-image
                  :src="form.startImg"
                  v-if="form.startImg"
                  class="avatar"
                  alt=""
                  :fit="'contain'"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-form-item>

            <el-form-item v-if="allowUpload && form.mediaType === 'image'">
              <el-button type="warning" @click="clearImage">{{
                $t("settings.clearImg")
              }}</el-button>
            </el-form-item>

            <el-form-item label="视频链接" v-if="form.mediaType === 'video'">
              <el-input
                v-model="form.videoLink"
                placeholder="请输入视频的嵌入式 URL (例如: https://www.youtube.com/embed/... 或 B站 embed 链接)"
                size="large"
                clearable
              />
              <div style="font-size: 12px; color: #909399; margin-top: 4px">
                * 提示：为了能在 iframe
                中正常播放，请确保使用的是支持跨域嵌入的链接（通常带有 /embed/
                或 player 路径）。
              </div>
            </el-form-item>

            <el-form-item>
              <el-button
                type="success"
                size="large"
                style="background: #4f4f4f; color: #fff; margin-top: 20px"
                @click="handleSave"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <div class="panel_right">
          <p class="title">App示意图</p>
          <div class="example">
            <div class="media-preview-box">
              <img
                v-if="form.mediaType === 'image'"
                :src="form.startImg"
                alt="预览图片"
              />
              <div
                v-else-if="form.mediaType === 'video'"
                class="video-container"
              >
                <iframe
                  v-if="form.videoLink"
                  :src="form.videoLink"
                  scrolling="no"
                  border="0"
                  frameborder="no"
                  framespacing="0"
                  allowfullscreen="true"
                  class="preview-iframe"
                ></iframe>
                <div v-else class="video-placeholder">
                  <el-icon style="font-size: 32px"><VideoPlay /></el-icon>
                  <p style="margin-top: 8px; font-size: 13px">暂无视频链接</p>
                </div>
              </div>
            </div>

            <p>{{ form.startTitle }}</p>
            <p style="white-space: pre-wrap">
              {{ form.startContent }}
            </p>
            <p>
              <span>继续</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Plus, VideoPlay } from "@element-plus/icons-vue";
import { ElMessage, ElNotification } from "element-plus";

export default defineComponent({
  name: "App",
  components: { Plus, VideoPlay },
  props: ["dataForm"],
  data(): any {
    return {
      form: {
        id: null,
        gameId: null,
        startTitle: "",
        startContent: "",
        mediaType: "image",
        videoLink: "",
        startImg: "",
        endTitle: null,
        endContent: null,
        endImg: null,
        createTime: null,
      },
      fileList: [],
    };
  },
  computed: {
    story(): number {
      return this.$store.state.game.story;
    },
    allowUpload() {
      return this.form.startImg !== "" && this.form.startImg !== null;
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {
    if (
      JSON.stringify(this.$store.state.game.story) == "{}" ||
      this.$store.state.game.story.gameId != this.$route.params.id
    ) {
      this.$store
        .dispatch("game/getStory", { gameId: this.$route.params.id })
        .then((res: any) => {
          console.log(res);
          this.form = { ...this.form, ...res };
          this.initMediaData();
        })
        .catch(() => {});
    } else {
      this.form = { ...this.form, ...this.$store.state.game.story };
      this.initMediaData();
    }
  },
  methods: {
    // 5. 优化初始化媒体逻辑
    initMediaData() {
      // 优先看后端有没有直接返回 mediaType 和 videoLink
      if (this.form.mediaType && this.form.videoLink) {
        return;
      }

      // 如果后端没加这两个字段，或者它们是空的，使用老数据做降级兼容：
      if (
        this.form.startImg &&
        (this.form.startImg.includes("embed") ||
          this.form.startImg.includes("player"))
      ) {
        this.form.mediaType = "video";
        this.form.videoLink = this.form.startImg;
        this.form.startImg = "";
      } else if (this.form.startImg) {
        this.form.mediaType = "image";
      }
    },
    // 6. 保存逻辑
    handleSave() {
      const storyStart = {
        id: this.form.id,
        title: this.form.startTitle,
        content: this.form.startContent,
        img: this.form.mediaType == "image" ? this.form.startImg : "",
        mediaType: this.form.mediaType,
        videoLink: this.form.mediaType == "video" ? this.form.videoLink : "",
      };

      this.$store
        .dispatch("game/updateGameStart", storyStart)
        .then((res: any) => {
          this.form = { ...this.form, ...res };
          ElMessage.success({
            message: "修改成功",
          });
        })
        .catch(() => {});
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于2m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      return true;
    },
    handleAvatarSuccess(response: any) {
      this.form.startImg = response.data.returnFileUrl;
    },
    clearImage() {
      this.form.startImg = "";
      this.fileList = [];
    },
  },
});
</script>

<style lang="less" scoped>
.panel {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 30px;

  &_left {
    width: 50%;
  }

  &_right {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;

    .title {
      margin-bottom: 20px;
      font-size: 1vw;
    }

    .example {
      width: 300px;
      height: 500px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      position: relative;
      background: #fff;
      overflow: hidden;

      // 5. 规范化示意图媒体区域的样式
      .media-preview-box {
        width: 100%;
        height: 50%;
        background-color: #f5f7fa;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .video-container {
          width: 100%;
          height: 100%;
          position: relative;

          .preview-iframe {
            width: 100%;
            height: 100%;
            border: none;
          }

          .video-placeholder {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #909399;
            background: #f5f7fa;
          }
        }
      }

      p {
        &:nth-child(2) {
          width: 100%;
          height: auto;
          text-align: center;
          box-sizing: border-box;
          padding: 10px;
          margin: 0;
        }

        &:nth-child(3) {
          width: 100%;
          height: 140px;
          overflow-y: scroll;
          font-family: 新宋体;
          box-sizing: border-box;
          padding: 10px;
          text-align: left;
          margin: 0;
        }

        &:nth-child(4) {
          position: absolute;
          bottom: 20px;
          left: 100px;
          width: 100px;
          height: 40px;
          background: rgb(45, 168, 224);
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          margin: 0;
        }
      }
    }
  }
}

.box {
  width: 100px;
  height: 100px;
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

.avatar-uploader {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader:hover {
  border-color: var(--el-color-primary);
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
